import styled from 'styled-components'
export const HeaderLogoContent = styled.div`
  height: 62px;
`

export const HeaderTabsContent = styled.div`
  height: 36px;
`
